import React, { useState, useEffect } from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const DailySpecials = () => {
  const [timeLeft, setTimeLeft] = useState({
    hours: 3,
    minutes: 45,
    seconds: 30
  });

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev?.seconds > 0) {
          return { ...prev, seconds: prev?.seconds - 1 };
        } else if (prev?.minutes > 0) {
          return { ...prev, minutes: prev?.minutes - 1, seconds: 59 };
        } else if (prev?.hours > 0) {
          return { hours: prev?.hours - 1, minutes: 59, seconds: 59 };
        }
        return prev;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const dailySpecials = [
  {
    id: 1,
    name: "Sfogliatelle Ricce",
    description: "Crispy shell-shaped pastry filled with sweet ricotta cream and candied orange peel",
    image: "https://images.unsplash.com/photo-1710167511199-04816f3196e3",
    imageAlt: "Golden crispy sfogliatelle pastries with layered shell texture filled with creamy ricotta on white ceramic plate",
    price: "$4.50",
    badge: "Today\'s Special",
    freshBatch: "Next batch at 2:00 PM"
  },
  {
    id: 2,
    name: "Panettone Tradizionale",
    description: "Classic Milanese sweet bread with candied fruits and raisins, perfect with espresso",
    image: "https://images.unsplash.com/photo-1605949790413-068f4b35ba52",
    imageAlt: "Traditional Italian panettone bread with golden dome top studded with candied fruits and raisins on rustic wooden board",
    price: "$24.99",
    badge: "Seasonal Favorite",
    freshBatch: "Available all day"
  },
  {
    id: 3,
    name: "Tiramisu Classico",
    description: "Layers of espresso-soaked ladyfingers with mascarpone cream and cocoa powder dusting",
    image: "https://images.unsplash.com/photo-1567588988863-bb7ca30a5914",
    imageAlt: "Classic tiramisu dessert with distinct layers of coffee-soaked ladyfingers and mascarpone cream topped with cocoa powder in glass dish",
    price: "$6.99",
    badge: "Customer Favorite",
    freshBatch: "Made fresh hourly"
  }];


  return (
    <section className="py-16 bg-card">
      <div className="container-custom">
        <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-6 mb-12">
          <div>
            <h2 className="font-serif text-4xl font-bold text-foreground mb-4">
              Today's Fresh Specials
            </h2>
            <p className="text-lg text-muted-foreground">
              Handcrafted daily with the finest ingredients
            </p>
          </div>

          <div className="flex items-center gap-4 p-4 rounded-xl bg-primary/10 border border-primary/20">
            <Icon name="Clock" size={24} color="var(--color-primary)" />
            <div>
              <p className="text-sm text-muted-foreground mb-1">Next fresh batch in</p>
              <div className="flex gap-2">
                <div className="text-center">
                  <div className="text-2xl font-bold text-primary">{String(timeLeft?.hours)?.padStart(2, '0')}</div>
                  <div className="text-xs text-muted-foreground">Hours</div>
                </div>
                <div className="text-2xl font-bold text-primary">:</div>
                <div className="text-center">
                  <div className="text-2xl font-bold text-primary">{String(timeLeft?.minutes)?.padStart(2, '0')}</div>
                  <div className="text-xs text-muted-foreground">Mins</div>
                </div>
                <div className="text-2xl font-bold text-primary">:</div>
                <div className="text-center">
                  <div className="text-2xl font-bold text-primary">{String(timeLeft?.seconds)?.padStart(2, '0')}</div>
                  <div className="text-xs text-muted-foreground">Secs</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {dailySpecials?.map((special) =>
          <div
            key={special?.id}
            className="group bg-background rounded-2xl overflow-hidden border border-border hover:shadow-warm-lg transition-all duration-300 hover:-translate-y-1">

              <div className="relative h-64 overflow-hidden">
                <Image
                src={special?.image}
                alt={special?.imageAlt}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />

                <div className="absolute top-4 left-4">
                  <div className="px-3 py-1 rounded-full bg-primary text-primary-foreground text-xs font-medium">
                    {special?.badge}
                  </div>
                </div>
              </div>

              <div className="p-6">
                <div className="flex justify-between items-start mb-3">
                  <h3 className="font-serif text-xl font-semibold text-foreground">
                    {special?.name}
                  </h3>
                  <span className="text-xl font-bold text-primary">{special?.price}</span>
                </div>

                <p className="text-sm text-muted-foreground mb-4 line-clamp-2">
                  {special?.description}
                </p>

                <div className="flex items-center gap-2 mb-4 text-sm text-accent">
                  <Icon name="Clock" size={16} />
                  <span>{special?.freshBatch}</span>
                </div>

                <Button variant="outline" fullWidth iconName="ShoppingBag" iconPosition="left">
                  Add to Order
                </Button>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>);

};

export default DailySpecials;